export default "__VITE_ASSET__BtSk8oxo__"